<template>
  <el-dialog :visible.sync="show" custom-class="error-dialog">
    <div class="icon"></div>
    <p>考试通过</p>
    <div class="btn" @click="toHome">返回首页</div>
  </el-dialog>
</template>
<script>
export default {
  name: "error-dialog",
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toHome() {
      this.$router.push({
        name: "Home"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.error-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 499px;
  height: 339px;
  font-size: 20px;
  border-radius: 10px;
  color: #272222;
  p {
    padding: 5px 0;
    font-weight: 500;
    text-align: center;
  }
  .icon {
    padding-top: 70px;
    background: url(~@/images/thumbs-up_icon.png) no-repeat;
    background-size: 70px 70px;
    background-position: center;
  }
  .btn {
    width: 397px;
    height: 60px;
    line-height: 60px;
    margin-top: 10px;
    font-weight: 500;
    text-align: center;
    border: 1px solid #272222;
    cursor: pointer;
  }
}
</style>
